import { cn } from "@/lib/utils";

/**
 * "Living" pill banner — signals that a page evolves with the work
 * it documents. Mirrors the LivingBanner from
 * DashboardArchitecturePage. Rose-tinted to match the editorial accent.
 */
export type LivingBannerProps = {
  /** The pill label. Default: "חי" — Hebrew for "Living". */
  label?: string;
  /** The body line. */
  message: string;
  /** Extra classes on the wrapper. */
  className?: string;
};

export function LivingBanner({
  label = "חי",
  message,
  className,
}: LivingBannerProps) {
  return (
    <div
      className={cn(
        "mb-7 flex flex-wrap items-center gap-3",
        "rounded-xl border border-dashed border-rose-300/80 bg-rose-50",
        "px-4 py-3",
        "text-[13px] text-stone-600",
        className,
      )}
    >
      <span
        className={cn(
          "rounded-full bg-rose-600 px-2.5 py-0.5",
          "text-[11px] font-bold uppercase tracking-[0.12em] text-white",
        )}
      >
        {label}
      </span>
      <span>{message}</span>
    </div>
  );
}
